module.exports = __webpack_public_path__ + "static/img/lost-ethereal-lucre-games-thumbnail.de69316.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/lost-ethereal/lost-ethereal-lucre-games-thumbnail.jpg
// module id = f1kN
// module chunks = 0